export default __webpack_public_path__ + "static/Quickorder-Sand-d08221db0432560de7ffd598ce9e9696.png";